(() => {
  const nav = document.querySelector('[data-nav]');
  if (!nav) return;
  const toggle = nav.querySelector('[data-nav-toggle]');
  const overlay = nav.querySelector('[data-nav-overlay]');
  const inertTargets = () => [document.getElementById('main'),
    document.querySelector('.shopify-section-footer')].filter(Boolean);
  addEventListener('scroll', () => nav.classList.toggle('is-scrolled', scrollY > 24), { passive: true });
  const close = (refocus) => {
    if (toggle.getAttribute('aria-expanded') !== 'true') return;
    toggle.setAttribute('aria-expanded', 'false'); overlay.hidden = true;
    document.documentElement.style.overflow = '';
    inertTargets().forEach(el => { el.inert = false; });
    if (refocus) toggle.focus();
  };
  toggle.addEventListener('click', () => {
    if (toggle.getAttribute('aria-expanded') === 'true') return close(true);
    toggle.setAttribute('aria-expanded', 'true'); overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    inertTargets().forEach(el => { el.inert = true; });
    overlay.focus();
    if (window.gsap && !matchMedia('(prefers-reduced-motion: reduce)').matches)
      gsap.fromTo(overlay.querySelectorAll('a'), { autoAlpha: 0, y: 24 },
        { autoAlpha: 1, y: 0, stagger: 0.06, duration: 0.5, ease: 'power3.out' });
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') close(true); });
  matchMedia('(min-width: 1440px)').addEventListener('change', (e) => { if (e.matches) close(false); });
})();
